import { Component, h } from 'preact';
import * as accounting from 'accounting';

import { Listing } from '../../../../../types/listing.model';
import { hopplerApi } from '../../../../../constants';
import { divCatUtils } from '../../../../utils/div-cat-utils';
import { propertyUtils } from '../../../../../core/property-utils';
import { options } from '../../../../../constants/options';

interface InqPropCardPropertySectionProps {
  listing: Listing;
}

export class InqPropCardPropertySection extends Component<InqPropCardPropertySectionProps> {
  getImagePath(path: string) {
    if (path) {
      return `${hopplerApi.images}/${path}`;
    } else {
      return hopplerApi.noPhoto;
    }
  }

  getListingPrimaryPhoto(listing: Listing) {
    if (listing.multimedia) {
      const path = this.getImagePath(listing.multimedia[0].original);
      return `${path}?sg=propertycard`;
    } else {
      return hopplerApi.noPhoto;
    }
  }

  getUpperIconsRow(listing: Listing) {
    const icons: { icon: string; value: string }[] = [];

    if (listing.division === 'Residential') {
      if (listing.bedrooms !== undefined) {
        icons.push({ icon: 'fas fa-bed', value: `${ listing.bedrooms === 0 ? 'Studio' : listing.bedrooms }` });
      }
      
      if (listing.bathrooms !== undefined) {
        icons.push({ icon: 'fas fa-shower', value: `${ listing.bathrooms }` });
      }

      if (listing.parkingSpaces !== undefined && listing.parkingSpaces !== null) {
        icons.push({ icon: 'fas fa-parking', value: `${ listing.parkingSpaces }` });
      }
    }

    // There isn't enough room for decimal places
    if (listing.floorArea) {
      icons.push({ icon: 'fas fa-expand', value: `${ Math.floor(listing.floorArea) } FA` });
    } else {
      icons.push({ icon: 'fas fa-expand', value: `${ Math.floor(listing.lotArea) } LA` });
    }

    return icons.map(icon => <li><i className={ `fa-fw ${icon.icon}` } /> { icon.value }</li>);
  }


  getPriceString(listing: Listing) {
    const divCat = divCatUtils.fromListing(listing);
    const price = accounting.formatMoney(listing.minPrice, 'Php ', 0);
    if (propertyUtils.shouldShowRentalPrice(divCat)) {
      return `${price}/month`;
    } else if (propertyUtils.shouldShowSalePrice(divCat)) {
      return price;
    }
  }

  getDiscountedPriceString(listing: Listing) {
    const divCat = divCatUtils.fromListing(listing);
    const price = accounting.formatMoney(listing.discountedPrice, 'Php ', 0);
    return price;
  }

  getFurnishingText(listing: Listing) {
    switch (listing.furnishing) {
      case 'Fully Furnished':
        return 'FF';
      case 'Semi-Furnished':
        return 'SF';
      case 'Unfurnished':
      default:
        return 'UF';
    }
  }

  render(props: InqPropCardPropertySectionProps) {
    const { listing } = props;
    let discounted = listing.minPrice != listing.discountedPrice;
    if (!options.discountEnabled) {
      discounted = false;
    }

    return (
      <div className="hi-inqpropcard__property">
        <img className="hi-inqpropcard__propimg" src={ this.getListingPrimaryPhoto(listing) } />
        <span className="hi-inqpropcard__propid">
          { listing.propertyKey }

          {/*
            This component is also used in the inquiry details card's selected
            properties list, which sometimes returns properties without including
            their source.

            To prevent us from showing a "()", check the source first:
          */}
          { listing.source && ` (${listing.source})`}
        </span>
        <span className="hi-inqpropcard__address">{ listing.address }</span>
        { discounted &&
        <span className="hi-inqpropcard__price">{ this.getDiscountedPriceString(listing) } { <span style="text-decoration:line-through;">{ this.getPriceString(listing) }</span> }</span>
        }
        { !discounted &&
          <span className="hi-inqpropcard__price">{ this.getPriceString(listing) }</span>
        }
        {/* ICON ROW */}
        <div className="hi-inqpropcard__info-icons-group">
          <ul className="hi-inqpropcard__info-icons-row hi-inqpropcard__brba-icons list-unstyled">
            { this.getUpperIconsRow(listing) }
          </ul>
          <ul className="hi-inqpropcard__info-icons-row hi-inqpropcard__furnish-loc-icons list-unstyled">
            <li><i className="fas fa-couch" /> { this.getFurnishingText(listing) }</li>
            <li><i className="fas fa-map-pin" /> { listing.city }</li>
          </ul>
        </div>
      </div>
    );
  }
}
